function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Event = /*#__PURE__*/_createClass(function Event() {
  var _this = this;

  _classCallCheck(this, Event);

  _defineProperty(this, "listeners", []);

  _defineProperty(this, "on", function (callback) {
    _this.listeners.push(callback);
  });

  _defineProperty(this, "off", function (callback) {
    var index = _this.listeners.indexOf(callback);

    if (index >= 0) {
      _this.listeners.splice(index, 1);
    }
  });

  _defineProperty(this, "fire", function (data) {
    _this.listeners.forEach(function (listener) {
      if (typeof listener === 'function') {
        listener(data);
      }
    });
  });
});

export { Event as default };
//# sourceMappingURL=event.js.map